$(document).ready(function () {
    $('.dashboard-toggle').click(function () {
        // Store toggled status in local storage
        let target = $(this).data('target-id');
        $('#' + target).slideToggle();
        $(this).toggleClass('fas fa-chevron-up fas fa-chevron-down');
        let status = $(this).hasClass('fa-chevron-up') ? 1 : 0;

        $.ajax({
            url: `/api/dashboard/toggle/${status}/${target}`,
            type: 'GET',
            success: function (response) {
                console.log(response);
            }
        });
    });
});
